import { render, staticRenderFns } from "./MeasureWeightDialog.vue?vue&type=template&id=ac3f84f0&scoped=true&"
import script from "./MeasureWeightDialog.vue?vue&type=script&lang=js&"
export * from "./MeasureWeightDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3f84f0",
  null
  
)

export default component.exports